import { createApp } from "vue";
import App from "./App.vue";
import router from '../src/router/router'

createApp(App)
.use(router)
.component("font-awesome-icon", FontAwesomeIcon)
.mount("#app");

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { faJava } from "@fortawesome/free-brands-svg-icons";
import { faCircleArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
library.add(
  faGithub,
  faLinkedin,
  faFilePdf,
  faJava,
  faCircleArrowRight,
  faCirclePlay,
  faEnvelope
);


